module.exports = __webpack_public_path__ + "static/media/grey-circle.4453c767.svg";